module.exports = __webpack_public_path__ + "/images/cover-box-sorteo-resp.5f41ac9.jpg";